<template lang="html">
    <vs-popup :active.sync="$props.popupActive" title="Annonce">
        {{notice.notice}}
             <!-- </vx-card> -->
            </vs-popup>
         </template>

	<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VueCookies from "vue-cookies";
import store from "@/store/store";
export default {
	created() {
		this.consultantList = this.allCollaborators;
		//getting orders which belongs to user sign in
	},
	updated() {
		// //console.log("dsadsads");
		// this.getNotes();
	},
	components: {},
	mounted() {},
	name: "AnnoucementPopup",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: Boolean,
		notice: String,
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			newNote: "",
			notes: [],
		};
	},
	computed: {},
	methods: {
		/*
		 * changeConsultant(consultant){
		 * 	this.selectedCommercial = consultant;
		 * 	//console.log(consultant);
		 * }
		 */
	},
	watch: {},
};
</script>
